const businessTypes = {
  US: [
    {
      value: 1,
      label: 'screens.businessInformation.businessTypesUsa.soleTrader',
      description: 'screens.businessInformation.businessTypesUsa.soleTraderDescription',
    },
    {
      value: 6,
      label: 'screens.businessInformation.businessTypesUsa.llc',
      description: 'screens.businessInformation.businessTypesUsa.llcDescription',
    },
    {
      value: 4,
      label: 'screens.businessInformation.businessTypesUsa.nfp',
      description: 'screens.businessInformation.businessTypesUsa.nfpDescription',
    },
    {
      value: 5,
      label: 'screens.businessInformation.businessTypesUsa.partnership',
      description: 'screens.businessInformation.businessTypesUsa.partnershipDescription',
    },
    {
      value: 7,
      label: 'screens.businessInformation.businessTypesUsa.ccorp',
      description: 'screens.businessInformation.businessTypesUsa.ccorpDescription',
    },
    {
      value: 8,
      label: 'screens.businessInformation.businessTypesUsa.scorp',
      description: 'screens.businessInformation.businessTypesUsa.scorpDescription',
    },
  ],
  AU: [
    {
      value: 1,
      label: 'screens.businessInformation.businessTypesAus.soleTrader',
      description: 'screens.businessInformation.businessTypesAus.soleTraderDescription',
    },
    {
      value: 2,
      label: 'screens.businessInformation.businessTypesAus.ltd',
      description: 'screens.businessInformation.businessTypesAus.ltdDescription',
    },
    {
      value: 4,
      label: 'screens.businessInformation.businessTypesAus.nfp',
      description: 'screens.businessInformation.businessTypesAus.nfpDescription',
    },
    {
      value: 5,
      label: 'screens.businessInformation.businessTypesAus.partnership',
      description: 'screens.businessInformation.businessTypesAus.partnershipDescription',
    },
    {
      value: 10,
      label: 'screens.businessInformation.businessTypes.trust',
      description: 'screens.businessInformation.businessTypes.trustDescription',
    },
  ],
  ES: [
    {
      value: 1,
      label: 'screens.businessInformation.businessTypes.soleTrader',
      description: 'screens.businessInformation.businessTypes.soleTraderDescription',
    },
    {
      value: 9,
      label: 'screens.businessInformation.businessTypes.organisation',
      description: 'screens.businessInformation.businessTypes.organisationDescription',
    },
  ],
  CA: [
    {
      value: 1,
      label: 'screens.businessInformation.businessTypes.soleTrader',
      description: 'screens.businessInformation.businessTypes.soleTraderDescription',
    },
    {
      value: 9,
      label: 'screens.businessInformation.businessTypes.organisation',
      description: 'screens.businessInformation.businessTypes.organisationDescription',
    },
  ],
  IE: [
    {
      value: 1,
      label: 'screens.businessInformation.businessTypes.soleTrader',
      description: 'screens.businessInformation.businessTypes.soleTraderDescription',
    },
    {
      value: 9,
      label: 'screens.businessInformation.businessTypes.organisation',
      description: 'screens.businessInformation.businessTypes.organisationDescription',
    },
  ],
  NZ: [
    {
      value: 1,
      label: 'screens.businessInformation.businessTypes.soleTrader',
      description: 'screens.businessInformation.businessTypes.soleTraderDescription',
    },
    {
      value: 9,
      label: 'screens.businessInformation.businessTypes.organisation',
      description: 'screens.businessInformation.businessTypes.organisationDescription',
    },
    {
      value: 10,
      label: 'screens.businessInformation.businessTypes.trust',
      description: 'screens.businessInformation.businessTypes.trustDescription',
    },
  ],
  GB: [
    {
      value: 1,
      label: 'screens.businessInformation.businessTypes.soleTrader',
      description: 'screens.businessInformation.businessTypes.soleTraderDescription',
    },
    {
      value: 9,
      label: 'screens.businessInformation.businessTypes.organisation',
      description: 'screens.businessInformation.businessTypes.organisationDescription',
    },
  ],
  default: [
    {
      value: 1,
      label: 'screens.businessInformation.businessTypes.soleTrader',
      description: 'screens.businessInformation.businessTypes.soleTraderDescription',
    },
    {
      value: 2,
      label: 'screens.businessInformation.businessTypes.ltd',
      description: 'screens.businessInformation.businessTypes.ltdDescription',
    },
    {
      value: 3,
      label: 'screens.businessInformation.businessTypes.cic',
      description: 'screens.businessInformation.businessTypes.cicDescription',
    },
    {
      value: 4,
      label: 'screens.businessInformation.businessTypes.nfp',
      description: 'screens.businessInformation.businessTypes.nfpDescription',
    },
    {
      value: 5,
      label: 'screens.businessInformation.businessTypes.partnership',
      description: 'screens.businessInformation.businessTypes.partnershipDescription',
    },
  ],
};

export default businessTypes;
